__turbopack_context__.v({
  "root": "LearnMoreButton-module__KI5skW__root",
});
